import * as React from 'react';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';
import SimpleIconAction, { TABLE_REMOVE_ACTION } from '../CmdTable/TableActions/SimpleIconAction';
import { TFuelCardRecords } from './interfaces';
import { TABLE_FUEL_CARD } from '../../Services/TableService';
import ConfirmToaster from '../Forms/ConfirmToaster/ConfirmToaster';
import DeleteAction from '../CmdTable/TableActions/DeleteAction';

interface IRemoveAction {
  data: TFuelCardRecords;
  handleRemove: (data: TFuelCardRecords) => void;
}

export default function RemoveAction(props: IRemoveAction) {
  const { formatMessage: f } = useIntl();
  const [isToastrOpened, setIsToastrOpened] = React.useState(false);

  const getRemoveConfirmDialogText = () => {
    const messages: string[] = [];
    const date = new Date();
    let deleteMessage = '';
    if (date <= new Date(props.data.validUntil)) {
      const validUntil = dayjs(props.data.validUntil).format('DD.MM.YYYY');
      messages.push(
        f({ id: 'table.confirm.dialog.remove.message.fuel.card.validUntil' }, { date: validUntil })
      );
    }
    if (props.data.assignedTo && props.data.assignedTo !== '[N/A]') {
      messages.push(
        f(
          { id: 'table.confirm.dialog.remove.message.fuel.card.vehicleId' },
          { name: props.data.assignedTo }
        )
      );
    }
    messages.push(
      `${date <= new Date(props.data.validUntil) || props.data.assignedTo ? '<br />' : ''}${f({
        id: 'table.confirm.dialog.remove.message.fuel.card',
      })}`
    );

    deleteMessage = messages.join('<br />');
    return deleteMessage;
  };

  const handleConfirmCancel = (
    event?: React.MouseEvent<HTMLAnchorElement, MouseEvent> | KeyboardEvent
  ) => {
    if (event) event.preventDefault();
    setIsToastrOpened(false);
  };

  const handleToastr = () => {
    setIsToastrOpened(true);
  };

  const handleOnClick = () => {
    setIsToastrOpened(false);
    props.handleRemove(props.data);
  };

  return (
    <>
      <DeleteAction
        id={props.data.id}
        tableName={TABLE_FUEL_CARD}
        customerId={props.data.customerId.id}
        onClickCallback={handleToastr}
      />
      {isToastrOpened && (
        <ConfirmToaster
          id="toast"
          title={f({
            id: 'table.confirm.dialog.remove.title',
          })}
          message={getRemoveConfirmDialogText()}
          type="warning"
          duration={null}
          onClose={handleConfirmCancel}
          buttons={[
            {
              title: f({
                id: 'form.cancel',
              }),
              style: 'link',
              type: 'cancel',
              onClickCallback: handleConfirmCancel,
            },
            {
              title: f({
                id: 'table.deleteBtn',
              }),
              style: 'solid',
              type: 'confirm',
              onClickCallback: handleOnClick,
            },
          ]}
        />
      )}
    </>
  );
}
